import {
  EventDateInventoriesSearch,
  EventDateTicketInventory,
  SeasonTicketStoreItem,
  TicketSearch,
} from '@givebacks/api/store';
import { createTable } from 'core/Packages';

import { BreakdownType } from '../context/EventSalesBreakdown.context';

type EventSalesBreakdownTableInstanceMeta = {
  causeId?: string;
  breakdownType: BreakdownType;
  eventId?: string;
};

type EventSalesInventoryData = EventDateTicketInventory | SeasonTicketStoreItem;

type EventSalesBreakdownTableSearch = EventDateInventoriesSearch | TicketSearch;

const EventSalesBreakdownTableInstance = createTable<
  EventSalesInventoryData,
  EventSalesBreakdownTableSearch,
  EventSalesBreakdownTableInstanceMeta
>();

export { EventSalesBreakdownTableInstance };
export type { EventSalesBreakdownTableSearch, EventSalesInventoryData };
